<!--用户管理新建档案页面-->
<template>
    <a-spin :spinning="confirmLoading">
      <div>
        <a-row :gutter="16">
          <a-divider orientation="left">
              {{ $t('高拍仪操作') }}
          </a-divider>
          <a-col :span="24" style="margin-bottom: 10px;">
              <a-button type="primary" @click="readIDCard" style="margin-right: 20px;">
                  {{ $t('读二代身份证') }}
              </a-button>
              <a-button type="primary" @click="IDCardAndFaceIdentify" style="margin-right: 20px;">
                  {{ $t('人证识别') }}
              </a-button>
              <a-button type="primary" :disabled="!canWaterAgreement" @click="waterAgreement" style="margin-right: 20px;">
                  {{ $t('用水协议') }}
              </a-button>
              <a-button type="primary" @click="scanUserFolder" style="margin-right: 20px;">
                  {{ $t('扫描用户纸质资料') }}
              </a-button>
              <a-button type="primary" @click="userEvaluate">
                  {{ $t('用户评价') }}
              </a-button>
          </a-col>
        </a-row>
      </div>
        <a-steps :current="current" style="margin-bottom: 20px" @change="onChange">
            <a-step v-for="item in steps" :key="item.title" :title="item.title" />
        </a-steps>
        <j-form-container :disabled="formDisabled">
            <a-form :form="form" slot="detail" :colon="false" layout="vertical">
                <div class="form-contain">
                    <div v-show="current>=0" ref="current0">
                    <a-row :gutter="16" >
                        <a-divider orientation="left">
                            {{ $t('地址信息') }}
                        </a-divider>
                        <a-col :span="8">
                            <a-form-item :label="$t('区域名称')">
                                <a-input v-decorator="['userAreaName',validatorRules.userAreaName]" :placeholder="$t('请选择区域')" :readOnly="true" @click="setModalVisible(2)"></a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-item :label="$t('用户地址')" >
                                <a-input v-decorator="['userAddr',validatorRules.userAddr]" :placeholder="$t('请输入用户地址')"></a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-item :label="$t('表安装地址')">
                                <a-input v-decorator="['userMeterAddr',validatorRules.userMeterAddr]" :placeholder="$t('请输入水表安装地址')"></a-input>
                            </a-form-item>
                        </a-col>

                        <a-col :span="8">
                            <a-form-item :label="$t('安装经度')">
                                <a-input-number v-decorator="['userMeterLng',validatorRules.userMeterLng]" :placeholder="$t('请输入水表安装经度')" style="width:100%"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-item :label="$t('安装纬度')">
                                <a-input-number v-decorator="['userMeterLat',validatorRules.userMeterLat]" :placeholder="$t('请输入水表安装纬度')" style="width:100%"/>
                            </a-form-item>
                        </a-col>
                    </a-row>
                    </div>
                    <div v-show="current >= 1" ref="current1">
                    <a-divider orientation="left">
                        {{ $t('用户信息') }}
                    </a-divider>
                    <a-row :gutter="16" >
                        <a-col :span="8">
                            <a-form-item has-feedback :label="$t('用户编号')">
                                <a-input v-decorator.trim="['userId',validatorRules.userId]" :placeholder="$t('请输入用户编号')" :disabled="userIdDisabled"></a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-item :label="$t('用户姓名')">
                                <a-input v-decorator="['userName',validatorRules.userName]" :placeholder="$t('请输入用户姓名')"></a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-item :label="$t('手机号码')">
                                <a-input style="width:calc(100% - 50px)" v-decorator="['userPhone',validatorRules.userPhone]" :placeholder="$t('请输入用户手机号')"></a-input>
                                <a-button type="dashed" @click="addColumn">
                                    <a-icon type="plus" />
                                </a-button>
                            </a-form-item>
                        </a-col>
                        <a-col :span="8" v-for="(k, index) in form.getFieldValue('keys')" :key="k">
                            <a-form-item :label="$t('手机号码')">
                                <a-input style="width:calc(100% - 50px)" v-decorator="[`userPhone${k}`,validatorRules.userPhone]" :placeholder="$t('请输入用户手机号')"></a-input>
                                <a-icon
                                class="dynamic-delete-button"
                                type="minus-circle-o"
                                @click="() => removeColumn(k)"
                            />
                            </a-form-item>

                        </a-col>
                        <a-col :span="8">
                            <a-form-item :label="$t('身份证号')">
                                <a-input v-decorator="['userIdNumber',validatorRules.userIdNumber]" :placeholder="$t('请输入身份证号')"></a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-item :label="$t('用水户型')">
                                <a-select v-decorator="['userHouseholdCode',validatorRules.userHouseholdCode]" :placeholder="$t('请选择用水户型')" :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}">
                                    <a-select-option v-for="data in userHouseholdCodeList" :key="data.id" :value="data.id">
                                    {{ data.htName }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-item :label="$t('用户类型')">
                                <a-select v-decorator="['userTypeCode',validatorRules.userTypeCode]" :placeholder="$t('请选择用户类型')" :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}">
                                    <a-select-option v-for="data in userTypeList" :key="data.id" :value="data.id">
                                    {{data.utName}}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="8">
                          <a-form-item :label="$t('不动产权号/营业执照号')">
                              <a-input v-decorator="['realPropertyRights']" :placeholder="$t('请输入不动产权号/营业执照号')"></a-input>
                          </a-form-item>
                        </a-col>
                        <a-col :span="24">
                            <a-form-item :label="$t('用水协议')" >
                              <JUpload v-decorator="['fileList1']" :buttonVisible="false"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="24">
                            <a-form-item :label="$t('协议签名')" >
                              <j-image-upload class="avatar-uploader" :text="$t('上传')" :isMultiple="true" v-decorator="['userAgreementSignature']" :disabled="true"></j-image-upload>
                            </a-form-item>
                        </a-col>
                        <a-col :span="24">
                            <a-form-item :label="$t('用户资料')" >
                              <j-image-upload class="avatar-uploader" :text="$t('上传')" :isMultiple="true" v-decorator="['fileList2']" :disabled="true"></j-image-upload>
                            </a-form-item>
                        </a-col>
                        <a-col :span="24">
                            <a-form-item :label="$t('备注')" >
                                <a-textarea v-decorator="['remark']" rows="3" :placeholder="$t('请输入备注')" style="width:100%"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="24">
                            <a-collapse v-model="defaultkey">
                                <a-collapse-panel key="1" :header="$t('用户选填信息')" :forceRender="true">
                                    <a-row :gutter="16">
                                        <a-col :span="8">
                                        <a-form-item :label="$t('营收编号')">
                                            <a-input v-decorator="['userPayId']" :placeholder="$t('请输入用户营收编号')"></a-input>
                                        </a-form-item>
                                        </a-col>
                                        <a-col :span="8">
                                        <a-form-item :label="$t('身份类型')" >
                                            <a-select  v-decorator="['userIdType',{initialValue: 1}]" :placeholder="$t('请选择身份类型')" :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}">
                                            <a-select-option :value="1">
                                                {{ $t('自然人') }}
                                            </a-select-option>
                                            <a-select-option :value="0">
                                                {{ $t('企业') }}
                                            </a-select-option>
                                            </a-select>
                                        </a-form-item>
                                        </a-col>
                                        <a-col :span="8">
                                        <a-form-item :label="$t('小区名或村庄名')">
                                            <a-input v-decorator="['userCommName']" :placeholder="$t('请输入用户所在小区名或村庄名')"></a-input>
                                        </a-form-item>
                                        </a-col>
                                        <a-col :span="8">
                                        <a-form-item :label="$t('是否允许缴费')" >
                                            <j-dict-select-tag v-decorator="['userPayState', {initialValue: 1}]" :triggerChange="true" :showSearch="false" :placeholder="$t('请选择是否允许缴费')" dictCode="yn" style="width:100%"/>
                                        </a-form-item>
                                        </a-col>
                                        <a-col :span="8">
                                        <a-form-item :label="$t('优惠信息')">
                                            <j-dict-select-tag v-decorator="['userFreeinfo',validatorRules.userFreeinfo]" :triggerChange="true" :placeholder="$t('请选择水表用途')" dictCode="user_free_type" style="width:100%"/>
                                        </a-form-item>
                                        </a-col>
                                    </a-row>
                                </a-collapse-panel>
                            </a-collapse>
                        </a-col>
                    </a-row>
                    </div>
                    <div v-show="current >= 2" ref="current2">
                    <a-row :gutter="16" >
                        <a-divider orientation="left">
                            {{ $t('户号绑定') }}
                        </a-divider>
                        <a-col :span="8">
                            <a-form-item :label="$t('表编号')" :hasFeedback="true">
                                <a-input v-decorator="['meterId',validatorRules.meterId]" :placeholder="$t('请输入表编号')" :readOnly="true" @click="setModalVisible(1)"></a-input>
                            </a-form-item>
                        </a-col>
                    </a-row>
                    </div>
                </div>
                <a-modal v-model="modal2Visible" :title="title2" centered :width="width" :maskClosable="maskClosable">
                    <template slot="footer">
                        <a-button key="close" @click="handleCancel">
                        {{ $t('关闭') }}
                        </a-button>
                    </template>
                    <!-- <a-input-search v-model="selectedKeys" @search="onSearch" style="width:100%;margin-top: 10px" allowClear placeholder="请输入区域名称"/> -->
                    <a-input-search v-model="searchAreaValue" style="width:100%;margin-top: 10px" allowClear :placeholder="$t('请输入区域名称')"/>
                    <a-spin tip="Loading..." :spinning="areaLoading">
                        <!--
                        <a-tree 
                            show-line
                            @select="onSelect" 
                            :selectedKeys="selectedKeys" 
                            :treeData="areaTree" 
                            :checkStrictly="checkStrictly"
                            :expandedKeys="iExpandedKeys"
                            :autoExpandParent="autoExpandParent"
                            :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
                        @expand="onExpand">
                        <template slot="title" slot-scope="{title}">
                            <span v-if="title.indexOf(searchAreaValue) > -1" :title="title">
                                {{title.substr(0, title.indexOf(searchAreaValue))}}
                                <span style="color: #32CD32">{{searchAreaValue}}</span>
                                {{title.substr(title.indexOf(searchAreaValue) + searchAreaValue.length)}}
                            </span>
                            <span v-else :title="title">{{title}}</span>
                            </template>
                        </a-tree>
                        -->
                        <el-tree
                            class="filter-tree"
                            :data="areaTree"
                            :props="defaultProps"
                            :expand-on-click-node="false"
                            :filter-node-method="filterNode"
                            :check-on-click-node="true"
                            :check-strictly="checkStrictly"
                            :highlight-current="true"
                            node-key="id"
                            :current-node-key="currentNodeKey"
                            :default-expanded-keys="iExpandedKeys"
                            @node-click="nodeClick"
                            ref="areaTree">
                            </el-tree>
                    </a-spin>
                </a-modal>
                <a-modal v-model="modal1Visible" :title="title1" centered :width="width" :maskClosable="maskClosable">
                    <template slot="footer">
                        <a-button key="close" @click="handleCancel">
                        {{ $t('关闭') }}
                        </a-button>
                    </template>
                    <div class="form-contain">
                        <div class="table-page-search-wrapper">
                            <a-form layout="inline" @keyup.enter.native="searchQuery">
                                <a-row :gutter="24">
                                    <a-col :xl="12" :lg="7" :md="8" :sm="24">
                                        <a-form-item :label="$t('表编号')">
                                        <j-input :placeholder="$t('输入表编号模糊查询')" v-model="queryParam.meterId"></j-input>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :xl="8" :lg="7" :md="8" :sm="24">
                                        <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                                        <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                                        <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                                        <a-button type="primary" @click="addMeter" icon="plus" style="margin-left: 8px">{{ $t('添加表具') }}</a-button>
                                        </span>
                                    </a-col>
                                </a-row>
                            </a-form>
                        </div>

                        <a-table
                            :columns="columns"
                            :data-source="meteridlist"
                            rowKey='id'
                            size="middle"
                            :pagination="ipagination"
                            @change="handleTableChange"
                            >
                            <span slot="action" slot-scope="text, record">
                                <a-button type="primary" @click="handleEdit(record)">{{ $t('选择') }}</a-button>
                            </span>
                        </a-table>
                    </div>
                </a-modal>
                <a-modal v-model="modal3Visible" :title="title3" centered :width="width" :maskClosable="maskClosable">
                    <template slot="footer">
                        <a-button type="primary" @click="activation(1)">
                        {{ $t('确定') }}
                        </a-button>
                        <a-button key="close" @click="handleCancel">
                        {{ $t('取消') }}
                        </a-button>
                    </template>
                    <p>{{ $t('需要立即激活该用户吗?') }}</p>
                </a-modal>
            </a-form>
        </j-form-container>
        <div class="steps-action" style="text-align:center">
            <a-button v-if="current > 0"  @click="prev">
                {{ $t('前一步') }}
            </a-button>
            <a-col :span="12" :offset="6">
                <a-button size="large" block v-if="current == steps.length - 1" type="primary" @click="submitForm">
                    {{ $t('完成') }}
                </a-button>
            </a-col>
            <a-button v-if="current < steps.length - 1" style="margin-left: 8px" type="primary" @click="next">
                {{ $t('下一步') }}
            </a-button>
        </div>
        <meter-Activate-modal ref="ActivateForm" @ok="ActivateFormOK"></meter-Activate-modal>
        <MeterinfoModal ref="meterInfoForm" @ok="loadData"></MeterinfoModal>
        <readIDCardModal ref="readIDCardForm" @ok="readIDCardReturn"></readIDCardModal>
        <IDCardAndFaceIdentifyModal ref="IDCardAndFaceIdentifyForm" @ok="IDCardAndFaceIdentifyReturn"></IDCardAndFaceIdentifyModal>
        <WaterAgreementModal ref="WaterAgreementForm" @ok="WaterAgreementReturn"></WaterAgreementModal>
        <ScanUserFolderModal ref="ScanUserFolderForm" @ok="ScanUserFolderReturn"></ScanUserFolderModal>
        <userEvaluateModal ref="userEvaluateForm" @ok="userEvaluateReturn"></userEvaluateModal>
    </a-spin>
</template>

<script>
  import { httpAction, getAction,uploadAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { listSize } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JInput from '@/components/jeecg/JInput'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {AreaChoosetMixin} from '@/mixins/AreaChooseMixin'
  import { mixinDevice } from '@/utils/mixin'
  import { searchAreaByKeywords,queryAreaTreeList } from '@/api/api'
  import { isEmptyObject,isUndefinedAndNull,isUndefined } from '@/utils/validate'
  import MeterActivateModal from './MeterActivateModal'
  import { mapGetters } from 'vuex'
  import Vue from 'vue'
   
  import {CardIdNumberPattern,PhoneNumberPattern} from '@/utils/regPattern'
  import MeterinfoModal from './MeterinfoModal'
  import readIDCardModal from './readIDCardModal'
  import IDCardAndFaceIdentifyModal from './IDCardAndFaceIdentifyModal'
  import WaterAgreementModal from './WaterAgreementModal'
  import ScanUserFolderModal from './ScanUserFolderModal'
  import userEvaluateModal from './userEvaluateModal'
  import JImageUpload from '@/components/jeecg/JImageUpload.vue'
  import JUpload from '@/components/jeecg/JUpload'
  let id = 0;
  export default {
    name: 'MeterUserinfoForm',
    mixins:[JeecgListMixin, mixinDevice,AreaChoosetMixin],
    components: {
      JFormContainer,
      MeterActivateModal,
      JInput,
      MeterinfoModal,
      readIDCardModal,
      IDCardAndFaceIdentifyModal,
      WaterAgreementModal,
      ScanUserFolderModal,
      userEvaluateModal,
      JImageUpload,
      JUpload
    },
    data () {
      return {
        seen:false,
        record:'',
        condition:false,
        activeKey:[1,2],
        defaultkey:[1],
        form: this.$form.createForm(this),
        model: {},
        modal1Visible: false,
        modal2Visible: false,
        modal3Visible: false,
        maskClosable: false,
        width:800,
        confirmLoading: false,
        ipagination:{
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " " + this.$t('共{total}条', { total: total })
          },
          total: 0
        },
        selectedKeys: [],
        areaTree: [],
        canceldata:[],
        checkStrictly: true,
        iExpandedKeys: [],
        autoExpandParent: true,
        userHouseholdCodeList:[], // 用户户型
        userTypeList:[], //  类型编码
        // userPriceCode:[], // 价格编码
        meteridlist:[],  //表编号
        url: {
          list:"/jeecg-charge/meter/meterUserinfo/list",
          userIdIsOk:"/jeecg-charge/meter/meterUserinfo/userIdIsOk",
          meteridlist:"/jeecg-charge/meter/meterinfo/list",
          add: "/jeecg-charge/meter/meterUserinfo/add",
          edit: "/jeecg-charge/meter/meterUserinfo/edit",
          queryById: "/jeecg-charge/meter/meterUserinfo/queryById",
          userHouseholdCodeList: "/jeecg-charge/meter/meterHousehold/list",
          userTypeList: "/jeecg-charge/meter/meterUserType/list",
          userIdCreateRule: '/jeecg-charge/meter/departUserIdConfig/queryCurrentDepartUserIdRule',
          upload: "sys/common/upload",
        },
        current: 0,
        currSelected: {},
        areaLoading: false,
        disableMixinCreated: true,
        userIdDisabled: false,
        websocket: null,
        picData: '',
        picImg: '',
        pdfUrl: '',
        fileList1: [],
        fileList2: '',
        imgs: [],
      }
    },
    computed: {
      // i18n：列标题/步骤条/弹窗标题/校验消息使用 computed 以响应语言切换
      columns() {
        return [
        {
          title: this.$t('表编号'),
          align:"center",
          dataIndex: 'meterId'
        },{
          title: this.$t('表类型'),
          align:"center",
          dataIndex: 'mtName'
        },{
          title: this.$t('表口径'),
          align:"center",
          dataIndex: 'mtCaliber',
          customRender: (text,row) => {
              return 'DN'+text;
          }
        },{
          title: this.$t('水表厂商'),
          align:"center",
          dataIndex: 'mtComName'
        },{
          title: this.$t('操作'),
          dataIndex: 'action',
          align:"center",
          fixed:"right",
          width:90,
          scopedSlots: { customRender: 'action' }
          }
        ];
      },
      steps() {
        return [
          {
            title: this.$t('地址信息'),
          },
          {
            title: this.$t('用户信息'),
          },
          {
            title: this.$t('户号绑定'),
          }
        ];
      },
      title1() {
        return this.$t('请选择表编号')
      },
      title2() {
        return this.$t('请选择区域名称')
      },
      title3() {
        return this.$t('提示')
      },
      // i18n：校验消息使用 computed 以响应语言切换
      validatorRules() {
        return {
            userAreaName: {
                rules:[
                    {required:true, message:this.$t('请选择区域')},
                ]
            },

            userAddr: {
                rules:[
                    {required:true, message:this.$t('请输入用户地址'),whitespace: true},
                ]
            },
            /*
            userMeterAddr: {
                rules:[
                    {required:true, message:'请输入水表安装地址'},
                ]
            },
            */
          meterId:{   //表编号
            rules:[
              {required: true, message: this.$t('请输入表编号!'),whitespace: true},
            //   {validator: this.validatePlanName},
            ]
          },
          userId:{  //用户编号
            getValueFromEvent: (event) => {return event.target.value.replace(/\s+/g,"")},
            rules:[
              {required: true, message:this.$t('请输入用户编号'),whitespace: true},
              {
                validator: this.validateUserId
              }
            ]
          },
          userName:{ //用户姓名
            rules:[
                {required:true, message:this.$t('请输入用户姓名'),whitespace: true}
            ]
          },
          userPhone:{
            rules:[
                {required:true , message:this.$t('请输入手机号码'),whitespace: true},
                {pattern: PhoneNumberPattern,message: this.$t('请输入正确的手机号码')}
            ]
          },
          userIdNumber:{
            rules:[
                {required:false ,pattern: CardIdNumberPattern,message: this.$t('请输入正确的身份证号'),whitespace: true}
            ]
          },
          userAreaId:{  // 区域id
            rules:[
              {required:true, message:this.$t('请输入用户区域id！'),whitespace: true},
            ]
          },
        //   userPriceCode:{  //价格名称
        //     rules:[
        //       {required:true, message:'请选择价格编码！'},
        //     ]
        //   },
        }
      },
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      // 用水协议按钮可用条件：用户id存在 且 用户已激活(userState != 0)
      // userState 取值对齐列表页：0=未激活，非0=已激活
      canWaterAgreement(){
        return this.model && this.model.userId != null && this.model.userId !== ''
          && this.model.userState != null && this.model.userState !== 0;
      },
    },
    created () {
        this.form.getFieldDecorator('keys', { initialValue: [], preserve: true });
    },
    // beforeCreate() {
    //     this.form = this.$form.createForm(this, { name: 'dynamic_form_item' });
    //     this.form.getFieldDecorator('keys', { initialValue: [], preserve: true });
    // },
    watch: {
      searchAreaValue(val) {
        this.$refs.areaTree.filter(val);
        this.$nextTick(() => {
          this.changeTreeNodeStatus(this.$refs.areaTree.store.root);
        });
      }
    },
    mounted(){
      this.initWebSocket();
    },
    methods: {
      changeTreeNodeStatus(node) {// 搜索tree后只展开到当前搜索一级
        node.expanded = false;
        for (let i = 0; i < node.childNodes.length; i++) {
          node.childNodes[i].expanded = false;
          if(node.childNodes[i].data.areaName.indexOf(this.searchAreaValue)>-1){
          }
          if (node.childNodes[i].childNodes.length > 0) {
            node.expanded = true;
            this.changeTreeNodeStatus(node.childNodes[i]);
          }
        }
      },
      filterNode(value, data, node) {
        let parentNode = node.parent // 父级node
        let labels = [node.label] // 当前node的名字
        let level = 1 // 层级
        while (level < node.level) {
            labels = [...labels, parentNode.label] // 当前node名字，父级node的名字
            parentNode = parentNode.parent
            level++
        }
        return labels.some(d => d.indexOf(value) !== -1)
      },
        ...mapGetters(["userInfo"]),
        next() {
            this.current++;
            //window.location.hash = "#current"+this.current;
            console.log(this.$refs.current0)
            let that = this
            this.$nextTick(() => {
                that.$refs[`current${that.current}`].scrollIntoView(false)
            })
            
        },
        prev() {
            this.current--;
            //window.location.hash = "#current"+this.current;
            let that = this
            this.$nextTick(() => {
                that.$refs[`current${that.current}`].scrollIntoView(false)
            })
        },
        handleEdit(record) {
            console.log(record);
            this.form.setFieldsValue({
                'meterId' : record.meterId,
            });
            this.modal1Visible = false;
            this.searchReset();
        },
        onSelect(selectedKeys, e) {
            this.selectedKeys = selectedKeys;
            this.hiding = false
            let record = e.node.dataRef
            this.currSelected = Object.assign({}, record)
            this.form.setFieldsValue({
            'userAreaName' : this.currSelected.title,
            });
            this.modal2Visible = false
        },
        nodeClick(record,node,data) {
          // 选中和取消选中都会执行此方法，所以需要根据selected进行判做响应操作
            this.currentNodeKey = record.id
            this.$refs.areaTree.setCheckedKeys([record.id])
            //this.$refs.areaTree.setCurrentKey(record.id)
            this.currSelected = Object.assign({}, record);
            // 有的接口是areaId有的接口是userAreaId，兼容两个都写
             this.form.setFieldsValue({
            'userAreaName' : this.currSelected.areaName,
            });
            this.modal2Visible = false
          
        },
        searchReset() {
            this.queryParam = {}
        },
        handleTableChange(pagination, filters, sorter) {
            if (Object.keys(sorter).length > 0) {
                this.isorter.column = sorter.field;
                this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
            }
            this.ipagination = pagination;
            this.loadData();
        },
        setModalVisible(numm){
            if (numm==1) {
                if(!isUndefinedAndNull(this.model.userState)&&this.model.userState !== 0) {
                    // 如果已激活，不能重新选择表号
                    this.$message.error(this.$t("该用户已激活，不能重新选择表号！"))
                }else{
                    this.loadData(1);
                    this.modal1Visible = true;
                }
            } else if (numm==2) {
                this.loadTree()
                this.modal2Visible = true;
            } else if (numm==3) {
                this.modal3Visible = true;
            }
        },
        handleCancel(){
            this.modal1Visible = false;
            this.modal2Visible = false;
            this.modal3Visible = false;
            this.selectedKeys = [];
            this.currSelected = {};
            this.searchReset();
        },
        onChange(current) {
            this.current = current;
        },
        add (currSelected) {
            this.model = {};
            if (!isEmptyObject(currSelected)) {
                this.currSelected = currSelected
                console.error("current不为空")
                //this.form.setFieldsValue({
                  //  'userAreaName' : currSelected.title
                //});
                //this.modal2Visible = false
                this.edit({userAreaName: currSelected.title});
            } else {
                this.edit({});
            }
            // 查询用户编号生成规则
            let params = {}
            let that = this;
            getAction(this.url.userIdCreateRule, params).then((res) => {
              if (res.success&&res.result!=null) {
                  that.$nextTick(() => {
                    that.form.setFieldsValue({userId: res.result.userIdCreateCurrentComp});
                })    
              }
            })
        },
        edit (record) {
            this.queryUserTypeList();
            this.queryUserHouseholdCodeList();
            this.form.resetFields();
            this.model = Object.assign({}, record);
            this.visible = true;
            
            this.$nextTick(() => {
                let userPhoneArr = [];
                if(this.model.userPhone) {
                    let userPhone = this.model.userPhone;
                    userPhoneArr = userPhone.split(',');
                    if(userPhoneArr.length>1) {
                        id = userPhoneArr.length-1;
                        this.model.userPhone = userPhoneArr[0];
                        let keys = [];
                        for(let i =0;i<userPhoneArr.length-1;i++) {
                            keys[i] = i;
                        }
                        this.form.setFieldsValue({keys:keys});
                    }
                }
                console.log(this.model.userPhone)
                this.form.setFieldsValue(pick(this.model,'userArea','userAreaName','userAddr','userMeterAddr','userMeterLng','userMeterLat','userId','userName','userPhone','userIdNumber','userHouseholdCode','userTypeCode','remark','userPayId','userIdType','userCommName','userPayState','userFreeinfo','meterId','realPropertyRights','isCertified','userAgreementUrl','userAgreementSignature','userMessagePictureUrl'));
                if(this.model.userAgreementUrl){
                  this.form.setFieldsValue({
                    'fileList1':[this.model.userAgreementUrl]
                  })
                } 
                // this.fileList1 = [this.model.userAgreementUrl];
                this.imgs = this.model.userMessagePictureUrl ? this.model.userMessagePictureUrl.split(',') : [];
                this.form.setFieldsValue({
                  'fileList2':this.imgs&&this.imgs.join(',')
                })
                // this.fileList2 = imgs.join(',');
                // this.form.setFieldsValue({userArea: {label: this.model.userAreaName,value: this.model.userAreaId}});
                if(!!this.model.id) {
                    this.selectedKeys = [this.model.userAreaId];
                    this.userIdDisabled = true;
                }else{
                  this.userIdDisabled = false;
                }
                //let obj = {};
                //obj['userPhone'+0] = '123456789';
                setTimeout(()=> {
                    for(let i = 0;i<userPhoneArr.length-1;i++) {
                        let obj = {};
                        obj['userPhone'+i] = userPhoneArr[i+1];
                        this.form.setFieldsValue(obj);
                    }
                    
                },800)
            })    
        },

        submitForm () {
            const that = this;
            // 触发表单验证
            this.form.validateFieldsAndScroll((err, values) => {
                if (!err) {
                    that.confirmLoading = true;
                    let formData = Object.assign({}, values);
                    const keys = this.form.getFieldValue('keys');
                    console.log(keys);
                    let phoneStr = formData.userPhone;
                    for(let i =0;i<keys.length;i++) {
                        phoneStr+=","+formData['userPhone'+keys[i]]
                        delete formData['userPhone'+keys[i]]
                    }
                    formData.userPhone = phoneStr;
                    let httpurl = '';
                    let method = '';
                    if(!this.model.id){
                    httpurl+=this.url.add;
                    method = 'post';
                    }else{
                    httpurl+=this.url.edit;
                    method = 'put';
                    formData.id = this.model.id;
                    // 必须设置,英文后台设置的是null可以进行更新，所以如果不设置则编辑信息时会将该字段(卡号)进行重置
                    formData.userRes1 = this.model.userRes1;
                    }
                    
                    formData.userAreaName = this.currSelected.title ? this.currSelected.title:this.model.userAreaName;
                    formData.userAreaId = this.currSelected.value ? this.currSelected.value:this.model.userAreaId;
                    
                    formData.isCertified = this.model.isCertified;
                    formData.userAgreementUrl = this.form.getFieldValue('fileList1') && this.form.getFieldValue('fileList1').join(',');
                    formData.userMessagePictureUrl = this.form.getFieldValue('fileList2') || '';
                    httpAction(httpurl,formData,method).then((res)=>{
                    if(res.success){
                        this.model.meterId = values.meterId;
                        this.model.userId = values.userId;
                        that.$message.success(res.message);
                        setTimeout(() => {
                            that.$emit('ok');
                        },400)
                        if(!this.model.id){
                            this.modal3Visible = true;
                        }
                    }else{
                        that.$message.warning(res.message);
                    }
                    }).finally(() => {
                    that.confirmLoading = false;
                    this.shut();
                    }) 
                }
            })
        },
        activate(record) {
            if (record.userId== '' && record.userId === null) {
                const h = this.$createElement;
                this.$info({
                title: this.$t('信息'),
                content: h('div', {}, [
                    h('p', this.$t('请开户后在进行激活！')),
                ]),
                onOk() {},
                });
            } else {
                this.$refs.ActivateForm.edit(record)
                this.$refs.ActivateForm.title = this.$t('激活')
            }
        },
        activation(arg) {
            this.modal3Visible = false;
            if(!this.url.list){
                this.$message.error(this.$t("请设置url.list属性!"))
                return
            }
            //加载数据 若传入参数1则加载第一页的内容
            console.log(this.model);
            if (arg === 1) {
                this.ipagination.current = 1;
            }if (this.model.meterId) {
                this.queryParam.meterId = this.model.meterId;
                this.queryParam.userId = this.model.userId;
                console.log(this.model);
                var params = this.getQueryParams();//查询条件
                this.loading = true;
            }
            console.log(params);
            getAction(this.url.list, params).then((res) => {
                if (res.success) {
                    let record={}
                    record = res.result.records[0];
                    console.log(this.record);
                    this.activate(record)
                }
                if(res.code===510){
                    this.$message.warning(res.message)
                }
                this.loading = false;
            })
        },
        ActivateFormOK() {
            this.$emit('ok');
        },
        queryUserHouseholdCodeList() {
            let params = {}
            params.pageNo = 1;
            params.pageSize = listSize;
            getAction(this.url.userHouseholdCodeList, params).then((res) => {
            if(res.success){
            this.userHouseholdCodeList = res.result.records;
            }
            })
        },
        queryUserTypeList() {
            let params = {}
            params.pageNo = 1;
            params.pageSize = listSize;
            getAction(this.url.userTypeList, params).then((res) => {
                if(res.success){
                this.userTypeList = res.result.records;
                console.log(this.userTypeList);
                }
            })
        },
        loadData(arg) {
        if(!this.url.list){
            this.$message.error(this.$t("请设置url.list属性!"))
            return
        }
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
            this.ipagination.current = 1;
        }
        var params = this.getQueryParams();//查询条件
        params.mtState = 0;
        this.loading = true;
        getAction(this.url.meteridlist, params).then((res) => {
            if (res.success) {
            this.meteridlist = res.result.records;
            // this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
            }
            if(res.code===510){
            this.$message.warning(res.message)
            }
            this.loading = false;
        })
        },
        // 查询用户编号是否重复
        validateUserId(rule, value, callback) {
          if(!this.model.id){
              if(isUndefined(value)||value.replace(/\s+/g,'') == '') {
                  callback()
                  return
              }
              let org = this.userInfo().orgCode
              let userId = this.form.getFieldValue('userId')//.replace(/\s/g,"");
              //this.form.setFieldsValue({userId: userId});
              let params = {userId: userId,sysOrgCode: org}
              getAction(this.url.userIdIsOk,params).then((res) => {
                  // if (res.success&&res.result.records.length>0) {
                  //     if(this.model.id&&res.result.records[0].id === this.model.id) {
                  //         callback()
                  //     }else{
                  //         callback("该用户编号已存在!")
                  //     }
                  // } else {
                  //     callback()
                  // }
                  if(res.success){
                    callback()
                  }else{
                    callback(this.$t("该用户编号已存在!"))
                  }
              })
            }else{
              callback()
            }
        },
        shut(){    //关闭按钮
            this.defaultkey = '';
            this.current = 0;
            this.form.resetFields();
            this.userIdDisabled = false;
        },
        removeColumn(k) {
            const { form } = this;
            // can use data-binding to get
            const keys = form.getFieldValue('keys');
            // We need at least one passenger

            // can use data-binding to set
            form.setFieldsValue({
                keys: keys.filter(key => key !== k),
            });
        },

        addColumn() {
            const { form } = this;
            // can use data-binding to get
            const keys = form.getFieldValue('keys');
            const nextKeys = keys.concat(id++);
            // can use data-binding to set
            // important! notify form to detect changes
            form.setFieldsValue({
                keys: nextKeys,
            });
        },
        // 添加表具
        addMeter(){
          this.$nextTick(()=>{
            this.$refs.meterInfoForm.add();
            this.$refs.meterInfoForm.title = this.$t('新增');
          });
        },
        // 高拍仪操作-读二代身份证
        readIDCard(){
          this.$refs.readIDCardForm.init();
        },
        // 读二代身份证-返回值
        readIDCardReturn(row){
          this.form.setFieldsValue({
            'userName' : row.name,
            'userIdNumber' : row.number,
            // 'userAddr': row.address
          });
        },
        // 高拍仪操作-人证识别
        IDCardAndFaceIdentify(){
          this.$refs.IDCardAndFaceIdentifyForm.init();
        },
        // 人证识别返回值
        IDCardAndFaceIdentifyReturn(returnValue){
          if(returnValue){
            // this.form.setFieldsValue({
            //   'isCertified' : 1
            // });
            this.model.isCertified = 1;
          }else{
            // this.form.setFieldsValue({
            //   'isCertified' : 0
            // });
            this.model.isCertified = 0;
          }
        },
        // 高拍仪操作-用水协议
        waterAgreement(){
          let userFields = {
            userName: this.form.getFieldValue('userName'),
            userAddr: this.form.getFieldValue('userAddr'),
            userPhone: this.form.getFieldValue('userPhone'),
            userIdNumber: this.form.getFieldValue('userIdNumber'),
            waterUseType: this.form.getFieldValue('userTypeCode'),
            signDateText: this.formatSignDate(new Date()),
            userId: this.model.id
          };
          this.$refs.WaterAgreementForm.init(this.$t('用水'), userFields, this.model.userAgreementUrl, this.form.getFieldValue('userAgreementSignature'));
        },
        // 格式化签订日期为 "yyyy年MM月dd日"，供合同PDF模板使用
        formatSignDate(date){
          let y = date.getFullYear();
          let m = date.getMonth() + 1;
          let d = date.getDate();
          let pad = (n) => (n < 10 ? '0' + n : '' + n);
          return y + '年' + pad(m) + '月' + pad(d) + '日';
        },
        // 用水协议返回值
        WaterAgreementReturn(returnValue){
          this.$nextTick(()=>{
            if(returnValue){
              this.form.setFieldsValue({
                'fileList1' : [returnValue.file],
              });
              this.form.setFieldsValue({
                'userAgreementSignature':returnValue.image
              });
              this.model.userAgreementUrl = this.form.getFieldValue('fileList1')&&this.form.getFieldValue('fileList1').join(',');
            }else{
              this.form.setFieldsValue({
                'fileList1' : [],
              });
              this.form.setFieldsValue({
                'userAgreementSignature':''
              });
              this.model.userAgreementUrl = this.form.getFieldValue('fileList1')&&this.form.getFieldValue('fileList1').join(',');
            }
          })
        },
        // 高拍仪操作-扫描
        scanUserFolder(){
          this.$nextTick(()=>{
            this.$refs.ScanUserFolderForm.init(this.imgs);
          })
        },
        // 扫描返回值
        ScanUserFolderReturn(returnValue){
          if(returnValue){
            this.form.setFieldsValue({
              'fileList2' : returnValue.scanImgs
            });
            this.imgs = returnValue.scanImgs ? returnValue.scanImgs.split(',') : [];
          }
        },
        // 高拍仪操作-用户评价
        userEvaluate(){
          this.$refs.userEvaluateForm.init();
        },
        // 用户评价返回值
        userEvaluateReturn(returnValue){
          
        },
        // websocket消息通知开始
        initWebSocket(){
          // WebSocket与普通的请求所用协议有所不同，ws等同于http，wss等同于https
          var userId = this.$store.getters.userInfo.id;
          // var url = window._CONFIG['domianURL'].replace("https://", "wss://").replace("http://", "ws://") + "/websocket/" + userId;
          var url = 'ws://localhost:19998/'
    
          //update-begin-author:taoyan date:2022-4-22 for:  v2.4.6 的 websocket 服务端，存在性能和安全问题。 #3278
          let token = Vue.ls.get('ACCESS_TOKEN')
    
          this.websocket = new WebSocket(url);
          //update-end-author:taoyan date:2022-4-22 for:  v2.4.6 的 websocket 服务端，存在性能和安全问题。 #3278
          this.websocket.onopen = this.websocketOnopen;
          this.websocket.onerror = this.websocketOnerror;
          this.websocket.onmessage = this.websocketOnmessage;
          this.websocket.onclose = this.websocketOnclose;
        },
        websocketOnopen() {
          console.log("WebSocket消息通知layout连接成功");
          //心跳检测重置
          // this.heartCheck.reset().start();
        },
        websocketOnerror(e) {
          console.log("WebSocket连接发生错误，第%s次", this.wsConnectErrorTime);
    
          this.wsConnectErrorTime = this.wsConnectErrorTime + 1;
          if (this.wsConnectErrorTime > 5) {
            console.log("WebSocket连接错误超过5次，就不再重新连了！");
            this.lockReconnect = true
            return;
          }
          // this.reconnect();
        },
        websocketOnmessage(e) {
          let data = JSON.parse(e.data); //解析json字符串
          console.log("WebSocket消息通知layout收到消息", data);
          // 按照实际需求处理消息（即只推送给含有特定消息类型的用户）
          // if(this.messageType.findIndex(item => item == data.port) == -1) {
          //   return
          // }
          console.log(data);
          if(data.Type == 1 && data.Method == "star_OpenCam" && data.nIndex == 1){// 打开摄像头结果
            if(data.ret == 0){
              let json = {"Type":"1","Method":"star_Preview"};// 打开预览
              this.websocketSend(JSON.stringify(json));
            }
          }else if(data.Type == 1 && data.Method == "star_OpenCam" && data.nIndex == 0){// 扫描用户纸质档案打开摄像头结果
            if(data.ret == 0){
              console.log('成功打开摄像头');
              // let json = {"Type":"1","Method":"star_Capture","nIndex":"0"};
              // this.websocketSend(JSON.stringify(json));
            }
          }else if(data.Type == 1 && data.Method == "star_Capture" && data.nIndex == 0){// 扫描用户纸质档案拍照结果
            if(data.ret == 0){
              // this.picData = "data:image/png; base64,"+data.szPhotoBase64;
              this.picImg = data.szPhotoBase64;
              this.picData = this.base64ToBlob(data.szPhotoBase64,'image/png');
              console.log('成功拍照'+JSON.stringify(this.picData));
              let json = {"Type":"1","Method":"star_CloseCam","nIndex":"0"};// 关闭摄像头
              this.websocketSend(JSON.stringify(json));
            }
          }else if(data.Type == 1 && data.Method == "star_CloseCam" && data.nIndex == 0){// 扫描用户纸质档案关闭摄像头结果
            if(data.ret == 0){
              console.log('成功关闭摄像头');
            }
          }else if(data.Type == 1 && data.Method == "star_Preview"){// 预览结果
            if(data.ret == 0){
              this.picData = "data:image/png; base64,"+data.szPhotoBase64;
            }
          }else if(data.Type == 1 && data.Method == "star_Capture" && data.nIndex == 1){// 客户头拍照结果
            if(data.ret == 0){
              this.picData = "data:image/png; base64,"+data.szPhotoBase64;
            }
          }
          // else if(data.Type == 1 && data.Method == "star_CloseCam" && data.nIndex == 1){// 关闭摄像头
          //   if(data.ret == 0){
          //     const picImg = atob(this.picImg);
          //     const picImgNumbers = new Array(picImg.length);
          //     for (let i=0;i<picImg.length;i++){
          //       picImgNumbers[i] = picImg.charCodeAt(i);
          //     }
          //     const picImgArray = new Uint8Array(picImgNumbers);
          //     var file = new File([picImgArray],'人脸照片',{type: 'image/png'});
          //     let formData = new FormData();
          //     formData.append('biz','temp');
          //     formData.append('file',file);
          //     uploadAction(this.url.upload,formData).then(res=>{
          //       if(res.success){
          //         res.message
          //         let json = {"Type":"5","Method":"star_GetFaceDetectResult","nPort":"0","nBaud":"9600","cBp":"0","nActionType":"1","szPicPath1":"D:\\head1.jpg","szPicPath2":res.message,"nTimeout":"60"};// 人脸核验
          //         this.websocketSend(JSON.stringify(json));
          //       }
          //     })
          //   }
          // }
          else if(data.Type == 4 && data.Method =="star_ReadIdInfo"){// 身份证识别结果
            // 二代身份证
            var szIdInfo = data.szIdInfo;
            var infoList = szIdInfo.split('|');
            this.form.setFieldsValue({
              'userName' : infoList[0],
              'userIdNumber' : infoList[5],
            });
            this.picImg = "data:image/png; base64,"+data.szPhotoBase64;
          }else if(data.Type == 5 && data.Method == 'star_GetFaceDetectResult'){// 人脸核验结果
            var ret = data.ret;
            var nResult = data.nResult;
            console.log("人脸核验结果-相似程度："+nResult);
          }else if(data.Type == 5 && data.Method == 'star_StartPDFSign'){
            // 无纸化-PDF电签
            var szPicData = data.szPicData;
            var szPdfData = data.szPdfData;
            this.picData = "data:image/png; base64,"+szPicData;
            const pdfUrl = atob(szPdfData);
            const pdfNumbers = new Array(pdfUrl.length);
            for (let i=0;i<pdfUrl.length;i++){
              pdfNumbers[i] = pdfUrl.charCodeAt(i);
            }
            const pdfArray = new Uint8Array(pdfNumbers);
            const blob = new Blob([pdfArray],{type: 'application/pdf'});
            this.pdfUrl = URL.createObjectURL(blob);
          }
          
          
          // this.openNotification(JSON.parse(data.message))
    
          //心跳检测重置
          //this.heartCheck.reset().start();
        },
        base64ToBlob(base64,type){
          let bytes = atob(base64);
          let ab = new ArrayBuffer(bytes.length);
          let ia = new Uint8Array(ab);
          for(let i=0;i<bytes.length;i++){
            ia[i] = bytes.charCodeAt(i);
          }
          
          let blob = new Blob([ab],{type:type});
          return URL.createObjectURL(blob)
        },
        websocketOnclose(e) {
          console.log("connection closed (" + e + ")");
          if (e) {
            console.log("connection closed (" + e.code + ")");
          }
          // this.reconnect();
        },
        websocketSend (text) { // 数据发送
          try {
            this.websocket.send(text);
          } catch (err) {
            console.log("send failed (" + err.code + ")");
          }
        },
    }
}
</script>
<style scoped>
.ant-form-item >>> .ant-select{
  width: 100%;
}
</style>